export default function Error404() {
  return <h1 className='error-404'>404</h1>;
}
